import React from 'react';
import './Table.css';
import { type TableProps } from '../../utils/interfaces';
import { useColumnVisibility } from './useColumnVisibility';

export const Table: React.FC<TableProps> = ({ thArray, tdArray, hasPadding = false, tableId }) => {
  const {
    isOpen,
    setIsOpen,
    pickerRef,
    visibleColumns,
    visibleCount,
    filteredThArray,
    filterRow,
    toggleColumn,
  } = useColumnVisibility(tableId, thArray);
  const filteredTdArray = tdArray.map(filterRow);

  return (
    <div style={{ marginBottom: '16px', overflowY: hasPadding ? 'auto' : 'unset' }}>
      {tableId && thArray.length > 1 && (
        <div className='table_toolbar' ref={pickerRef}>
          <button type='button' className='table_columns_button' onClick={() => setIsOpen(!isOpen)}>
            Столбцы
          </button>
          {isOpen && (
            <div className='table_columns_dropdown'>
              {thArray.map((th, index) => (
                <label key={`${th.name}-${index}`} className='table_columns_option'>
                  <input
                    type='checkbox'
                    checked={visibleColumns[index] ?? true}
                    disabled={(visibleColumns[index] ?? true) && visibleCount === 1}
                    onChange={() => toggleColumn(index)}
                  />
                  <span>{th.name || `Столбец ${index + 1}`}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      )}
      <table className={'table'}>
        <thead>
          <tr className={'column_header'}>
            {filteredThArray.map((th, index) => {
              return (
                <th style={th.style} key={index}>
                  {th.name}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {filteredTdArray.length === 0 ? (
            <tr>
              <td className={'empty_table'} colSpan={filteredThArray.length}>
                <img src={'/no_data_icon.png'} alt={'no data icon'} />
              </td>
            </tr>
          ) : (
            filteredTdArray.map((a, index) => {
              return (
                <tr key={index}>
                  {a.map((b, index) => {
                    return (
                      <td style={b.style} key={index}>
                        {' '}
                        {b.element}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};
